<template>
  <main class="unbind-result-page">
    <AppNavBar :title="statusInfo.title" :left-arrow="false" :auto-back="false" background-color="#ffffff" />

    <section class="result-content">
      <app-image :src="statusInfo.image" alt="" class="result-image" />
      <div class="result-text">{{ statusInfo.text }}</div>
      <p>{{ statusInfo.desc }}</p>
      <van-button block round type="primary" class="finish-btn" @click="finish">
        {{ t('common.finish') }}
      </van-button>
    </section>
  </main>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { getRouteState, navigateWithState } from '@/utils/route-state';
import successImage from '@/assets/images/cardImage/unbindStatus_one.png';
import failedImage from '@/assets/images/cardImage/unbindStatus_two.png';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const pageState = getRouteState(route, 'card-unbind-result', {});
const isSuccess = computed(() => String(pageState.status || '1') === '1');
const statusInfo = computed(() => isSuccess.value
  ? {
    title: t('card.unBindCardText_11'),
    text: t('card.unBindCardText_12'),
    desc: t('card.unBindCardText_13'),
    image: successImage
  }
  : {
    title: t('card.unBindCardText_14'),
    text: t('card.unBindCardText_15'),
    desc: t('card.unBindCardText_16'),
    image: failedImage
  });

const finish = () => {
  navigateWithState(router, '/home/card', {
    namespace: 'home-card',
    replace: true
  });
};
</script>

<style scoped lang="scss">
.unbind-result-page {
  min-height: var(--app-viewport-height);
  background: #ffffff;
}

.result-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px 24px 30px;
  text-align: center;
}

.result-image {
  width: 188px;
  height: 188px;
  object-fit: contain;
}

h1 {
  margin: 28px 0 0;
  color: #000000;
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
}

.result-text {
  margin-top: 18px;
  color: #000000;
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
}

.result-content p {
  max-width: 320px;
  margin: 8px 0 0;
  color: #666666;
  font-size: 14px;
  line-height: 22px;
}

.finish-btn {
  width: 100%;
  margin-top: 40px;
  font-weight: 700;
}
</style>
